// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   FormControlLabel,
//   Grid,
//   Switch,
//   TextField,
// } from "@mui/material";
// import { menuApi } from "../utils/menuApi";

// const defaultForm = {
//   name: "",
//   description: "",
//   image_url: "",
//   is_available: true,
//   is_veg: false,
//   tags: "",
//   display_order: 1,
// };

// const FoodTypeDialog = ({
//   open,
//   mode,
//   data,
//   token,
//   clientId,
//   locationId,
//   onClose,
//   onSuccess,
//   showSnackbar,
// }) => {
//   const [form, setForm] = useState(defaultForm);

//   useEffect(() => {
//     if (data) {
//       setForm({
//         name: data.name || "",
//         description: data.description || "",
//         image_url: data.image_url || "",
//         is_available: data.is_available ?? true,
//         is_veg: data.is_veg ?? false,
//         tags: Array.isArray(data.tags) ? data.tags.join(", ") : "",
//         display_order: data.display_order ?? 1,
//       });
//     } else {
//       setForm(defaultForm);
//     }
//   }, [data, open]);

//   const handleSave = async () => {
//     const payload = {
//       ...form,
//       tags: form.tags
//         ? form.tags.split(",").map((tag) => tag.trim()).filter(Boolean)
//         : [],
//       display_order: Number(form.display_order || 1),
//     };

//     try {
//       if (mode === "edit" && data?.id) {
//         await menuApi.updateFoodType({
//           token,
//           clientId,
//           locationId,
//           foodTypeId: data.id,
//           payload,
//         });
//         showSnackbar("Food type updated successfully");
//       } else {
//         await menuApi.createFoodType({ token, clientId, locationId, payload });
//         showSnackbar("Food type created successfully");
//       }
//       onSuccess();
//       onClose();
//     } catch (error) {
//       showSnackbar(error?.response?.data?.detail || "Failed to save food type", "error");
//     }
//   };

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
//       <DialogTitle>{mode === "edit" ? "Edit Food Type" : "Add Food Type"}</DialogTitle>
//       <DialogContent>
//         <Grid container spacing={2} sx={{ mt: 0.5 }}>
//           <Grid item xs={12}><TextField fullWidth label="Name" value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} /></Grid>
//           <Grid item xs={12}><TextField fullWidth label="Description" value={form.description} onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))} /></Grid>
//           <Grid item xs={12}><TextField fullWidth label="Image URL" value={form.image_url} onChange={(e) => setForm((p) => ({ ...p, image_url: e.target.value }))} /></Grid>
//           <Grid item xs={12}><TextField fullWidth label="Tags (comma separated)" value={form.tags} onChange={(e) => setForm((p) => ({ ...p, tags: e.target.value }))} /></Grid>
//           <Grid item xs={12} sm={6}><TextField fullWidth type="number" label="Display Order" value={form.display_order} onChange={(e) => setForm((p) => ({ ...p, display_order: e.target.value }))} /></Grid>
//           <Grid item xs={12} sm={6}>
//             <FormControlLabel control={<Switch checked={form.is_available} onChange={(e) => setForm((p) => ({ ...p, is_available: e.target.checked }))} />} label="Available" />
//             <FormControlLabel control={<Switch checked={form.is_veg} onChange={(e) => setForm((p) => ({ ...p, is_veg: e.target.checked }))} />} label="Veg" />
//           </Grid>
//         </Grid>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose}>Cancel</Button>
//         <Button variant="contained" onClick={handleSave}>Save</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default FoodTypeDialog;


import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { menuApi } from "../utils/menuApi";

const defaultForm = {
  name: "",
  description: "",
  image: null,
  is_available: true,
  is_veg: false,
  tags: "",
  display_order: 1,
};

const FoodTypeDialog = ({
  open,
  mode,
  data,
  token,
  clientId,
  locationId,
  onClose,
  onSuccess,
  showSnackbar,
}) => {
  const [form, setForm] = useState(defaultForm);

  useEffect(() => {
    if (data) {
      setForm({
        name: data.name || "",
        description: data.description || "",
        image: null,
        is_available: data.is_available ?? true,
        is_veg: data.is_veg ?? false,
        tags: Array.isArray(data.tags) ? data.tags.join(", ") : "",
        display_order: data.display_order ?? 1,
      });
    } else {
      setForm(defaultForm);
    }
  }, [data, open]);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0] || null;
    setForm((prev) => ({
      ...prev,
      image: file,
    }));
  };

  const handleSave = async () => {
    if (!form.name.trim()) {
      showSnackbar("Name is required", "error");
      return;
    }

    const payload = new FormData();
    payload.append("name", form.name);
    payload.append("description", form.description || "");
    payload.append("is_available", String(form.is_available));
    payload.append("is_veg", String(form.is_veg));
    payload.append("display_order", String(Number(form.display_order || 1)));

    const tags = form.tags
      ? form.tags.split(",").map((tag) => tag.trim()).filter(Boolean)
      : [];
    payload.append("tags", JSON.stringify(tags));

    if (form.image) {
      payload.append("image", form.image);
    }

    try {
      if (mode === "edit" && data?.id) {
        await menuApi.updateFoodType({
          token,
          clientId,
          locationId,
          foodTypeId: data.id,
          payload,
        });
        showSnackbar("Food type updated successfully");
      } else {
        await menuApi.createFoodType({
          token,
          clientId,
          locationId,
          payload,
        });
        showSnackbar("Food type created successfully");
      }

      onSuccess();
      onClose();
    } catch (error) {
      showSnackbar(
        error?.response?.data?.detail || "Failed to save food type",
        "error"
      );
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{mode === "edit" ? "Edit Food Type" : "Add Food Type"}</DialogTitle>

      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Name"
              value={form.name}
              onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Description"
              value={form.description}
              onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12}>
            <Button variant="outlined" component="label">
              Choose Image
              <input hidden type="file" accept="image/*" onChange={handleFileChange} />
            </Button>

            <Box sx={{ mt: 1 }}>
              <Typography variant="body2" color="text.secondary">
                {form.image
                  ? form.image.name
                  : data?.image
                  ? "Existing image available"
                  : "No image selected"}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Tags (comma separated)"
              value={form.tags}
              onChange={(e) => setForm((p) => ({ ...p, tags: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Display Order"
              value={form.display_order}
              onChange={(e) => setForm((p) => ({ ...p, display_order: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={form.is_available}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, is_available: e.target.checked }))
                  }
                />
              }
              label="Available"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={form.is_veg}
                  onChange={(e) => setForm((p) => ({ ...p, is_veg: e.target.checked }))}
                />
              }
              label="Veg"
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FoodTypeDialog;